import { render, staticRenderFns } from "./SvgPdf.vue?vue&type=template&id=54db71a6&scoped=true"
import script from "./SvgPdf.vue?vue&type=script&lang=ts"
export * from "./SvgPdf.vue?vue&type=script&lang=ts"
import style0 from "./SvgPdf.vue?vue&type=style&index=0&id=54db71a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54db71a6",
  null
  
)

export default component.exports